import { clockOffset } from "../../shared/price.ts";

/**
 * One shared client→server clock offset, refreshed from every segment fetch
 * (R-BRW-6). serverNow() is what every ticking component reads.
 */
let offset = 0;

export function syncClock(serverTs: number): void {
  offset = clockOffset(serverTs, Math.floor(Date.now() / 1000));
}

export function serverNow(): number {
  return Math.floor(Date.now() / 1000) + offset;
}

/** Stable per-listing tick offset so a grid does not tick in lockstep (08-design.md). */
export function tickStagger(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h % 1000;
}
